module.exports = __webpack_public_path__ + "static/media/Layout0.97145403.png";